import _default from './eventStack';
export { _default as default };